import { useEffect, useRef } from 'react';

// Website builder guide video hosted on HubSpot (HEA-2274). Values come from the official embed snippet.
const HUBSPOT_VIDEO = {
  embedId: 'external-embed-1789045792501',
  videoId: '469640685815',
  thumbnail:
    'https://26074018.fs1.hubspotusercontent-eu1.net/hub/26074018/hubfs/custom-video-thumbnails/Final%20Draft%20-%20Overlay-thumb.jpeg?length=1920',
  playButtonColor: '#309D6D',
  portalId: '26074018',
  region: 'eu1',
  loaderSrc: 'https://static.hsappstatic.net/video-embed/ex/loader.js',
} as const;

export default function HubSpotVideo(): JSX.Element {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    // The HubSpot loader looks for `.hs-video-widget` containers when it executes, so the script
    // is appended inside this widget on mount, mirroring the official embed snippet.
    const script = document.createElement('script');
    script.src = HUBSPOT_VIDEO.loaderSrc;
    script.type = 'text/javascript';
    script.dataset.hsPortalId = HUBSPOT_VIDEO.portalId;
    script.dataset.hsEnv = 'prod';
    script.dataset.hsExternal = 'true';
    script.dataset.hsSeo = 'true';
    script.dataset.hsRegion = HUBSPOT_VIDEO.region;
    container.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <div ref={containerRef} className="hs-video-widget" data-hsv-embed-id={HUBSPOT_VIDEO.embedId}>
      <img
        data-hsv-id={HUBSPOT_VIDEO.videoId}
        src={HUBSPOT_VIDEO.thumbnail}
        alt="Website builder"
        data-hsv-play-button-color={HUBSPOT_VIDEO.playButtonColor}
        data-hsv-width="100%"
      />
    </div>
  );
}
